import React from 'react';

export function CheckCircle(props) {
  const { fill = 'white', width = '16', height = '16', ...rest } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C11.8659 15 15 11.8659 15 8C15 4.13408 11.8659 1 8 1C4.13408 1 1 4.13408 1 8C1 11.8659 4.13408 15 8 15ZM11.2884 5.50877C11.0401 5.30348 10.6724 5.33834 10.4671 5.58663L7.35958 9.3451L5.43893 7.86811C5.18355 7.67172 4.81731 7.71954 4.62092 7.97493C4.42453 8.23031 4.47235 8.59655 4.72773 8.79294L6.87156 10.4416C7.24511 10.7288 7.77905 10.6687 8.07932 10.3055L11.3662 6.33004C11.5715 6.08175 11.5367 5.71405 11.2884 5.50877Z"
        fill={fill}
      />
    </svg>
  );
}
